module.exports = __webpack_public_path__ + "img/timer.2d0de22d.gif";